import { render, staticRenderFns } from "./ContactForm.vue?vue&type=template&id=52f3b8e3&scoped=true"
import script from "./ContactForm.js?vue&type=script&lang=js&external"
export * from "./ContactForm.js?vue&type=script&lang=js&external"
import style0 from "./ContactForm.vue?vue&type=style&index=0&id=52f3b8e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f3b8e3",
  null
  
)

export default component.exports